import React from 'react'
import WindowEvent from './'

const WindowResize = (props) => <WindowEvent type="resize" {...props} />

export default WindowResize
